import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../api.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HandlerService } from '../handler.service';
import { PdfService } from '../pdf.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-asso-service',
  templateUrl: './asso-service.component.html',
  styleUrls: ['./asso-service.component.scss'],
})
export class AssoServiceComponent {
  displayedColumns = ['name','service','date','S/P','cost'];
 
id;
details;
dateFormat;
items:any;
loader:boolean;
dataSource:any;
  constructor(private service: ApiService,private bottomSheet: MatBottomSheet, private handler: HandlerService, public pdf: PdfService, private router: Router, public auth: AuthService) { }
ionViewWillEnter(){
  this.loader = true;
  this.dateFormat = this.auth.getDateformat();
  let url = window.location.href;
  this.id = url.split("/").pop();
  let post ={
    "settlementInvoiceId" : this.id
  }
  this.service.getAppointReq2(post).subscribe((res: any) => {
    if(res){
    this.details=res;
    this.details.map(res =>{
      if(res.packageId){
      Object.assign(res, { searchFirstName: res.requestor.firstName,searchService:res.providerService.name,searchRequestId:res.id,Pack:res.packageId,cost:res.providerService.cost})
      }else{
        Object.assign(res, { searchFirstName: res.requestor.firstName,searchService:res.providerService.name,searchRequestId:res.id,Pack:'-',cost:res.providerService.cost})
      }
    })
    this.dataSource = new MatTableDataSource(this.details);
    this.loader = false;
    }else{
      this.loader = false;
      this.handler.res('No data for you')
    }
   },err => {
    this.loader = false;
    this.handler.err(err)
  })
}
}
